import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react/hooks';
import { gql } from '@yi/core';

import { useThrottle } from '~/common';

const SYNC_POSITION_FREQUENCY = 10 * 1000; //10 seconds

interface API {
  savePosition: (position: number) => void;
  forceSavePosition: (position: number) => void;
}

export function useSaveMediaPosition(
  contentId: string,
  contentType: gql.typesClient.MediaPositionContentType,
): API {
  const [saveMediaPosition] = useMutation<
    gql.typesClient.Mutate_SaveMediaPosition,
    gql.typesClient.Mutate_SaveMediaPositionVariables
  >(gql.Mutate_SaveMediaPosition);

  const savePosition = useCallback(
    (position: number) => {
      saveMediaPosition({
        variables: {
          content_id: contentId,
          content_type: contentType,
          position_in_seconds: Math.floor(position),
        },
      });
    },
    [contentId, contentType, saveMediaPosition],
  );
  const savePositionThrottled = useThrottle<Parameters<typeof savePosition>>(
    savePosition,
    SYNC_POSITION_FREQUENCY,
  );
  return { savePosition: savePositionThrottled, forceSavePosition: savePosition };
}
